import AxiosInstance from '../../../http-config'
import { EnumServicio, ConfigOperacionBalance } from '../..'
import { getAppConfigurationValue } from '../../../../redux'
import { AppConfigurationKey } from '../../../../model/enums/appConfigurationKey'

export const apiConfigServicioCapacidadGET = async (
  serviceTypes?: EnumServicio[]
): Promise<ConfigOperacionBalance[]> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentFrontServices)
  const operationTypesFilter = serviceTypes?.map(id => `servicio eq '${id}'`)

  return await AxiosInstance.get(
    `${apiSuffixUrl}/odata/ConfigServiciosCapacidad?api-version=1.0&$filter=(${operationTypesFilter?.join(
      ' or '
    )})`
  ).then(response => {
    return response.data.value
  })
}
